//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
  postBackendLogin,
} from "../../../helpers/fakebackend_helper";
import { setAuthorization, APIClient, getLoggedinUser } from "../../../helpers/api_helper";
import { api } from "../../../config";
import * as url from "../../../helpers/url_helper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag, loginBegin } from './reducer';

// const fireBaseBackend = getFirebaseBackend();

export const loginUser = (user, history) => async (dispatch) => {

  try {
    let response;
    dispatch(loginBegin()) 
    
    // Check if backend API URL is configured
    // Use backend if:
    // 1. REACT_APP_DEFAULTAUTH is set to "backend", OR
    // 2. REACT_APP_API_URL is explicitly set, OR
    // 3. API_URL is pointing to localhost:3000 (user's backend)
    const apiUrl = process.env.REACT_APP_API_URL || api.API_URL;
    const useBackend = process.env.REACT_APP_DEFAULTAUTH === "backend" || 
                       !!process.env.REACT_APP_API_URL || 
                       apiUrl.includes("localhost:3000");
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.loginUser(
        user.email,
        user.password
      );
    } else if (useBackend) {
      // Use backend API - send email and password
      response = postBackendLogin({
        email: user.email || user.username,
        password: user.password
      });
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtLogin({
        email: user.email,
        password: user.password
      });
    } else {
      response = postFakeLogin({
        email: user.email,
        password: user.password,
      });
    }
    
    var data = await response;

    if (data) {
      // Handle backend API response - common patterns:
      // { token: "...", user: {...} } or { accessToken: "...", user: {...} } or { data: { token: "...", user: {...} } }
      let token, userData;
      
      if (useBackend) {
        // Backend API response handling
        // The API returns { data: [{ user object with token }] }
        let responseData = data;
        
        // Handle array response format
        if (data.data && Array.isArray(data.data) && data.data.length > 0) {
          responseData = data.data[0];
        } else if (Array.isArray(data) && data.length > 0) {
          responseData = data[0];
        }
        
        token = responseData.token || responseData.accessToken || responseData.access_token;
        userData = responseData;
        
        // If token exists, set it in axios headers
        if (token) {
          setAuthorization(token);
        }
        
        // Fetch role details if roleID exists
        let roleData = null;
        let permissions = [];
        
        if (userData.roleID) {
          try {
            const apiClient = new APIClient();
            // Fetch role details by ID
            const roleResponse = await apiClient.get(`${url.GET_ROLE_BY_ID}/${userData.roleID}`);
            
            // Handle different response formats
            if (roleResponse.data && Array.isArray(roleResponse.data) && roleResponse.data.length > 0) {
              roleData = roleResponse.data[0];
            } else if (Array.isArray(roleResponse) && roleResponse.length > 0) {
              roleData = roleResponse[0];
            } else if (roleResponse.data) {
              roleData = roleResponse.data;
            } else {
              roleData = roleResponse;
            }
          } catch (roleError) {
            console.warn("Failed to fetch role details:", roleError);
            // Continue without role if API fails
          }
        }
        
        // Store auth data in sessionStorage (include refreshToken if backend sends it for refresh flow)
        const authData = {
          token: token,
          refreshToken: responseData.refreshToken ?? responseData.refresh_token,
          user: userData,
          role: roleData,
          permissions: permissions,
          ...responseData
        };
        sessionStorage.setItem("authUser", JSON.stringify(authData));
        
        dispatch(loginSuccess({
          user: userData,
          role: roleData,
          permissions: permissions
        }));
        history('/dashboard');
      } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        var finallogin = JSON.stringify(data);
        finallogin = JSON.parse(finallogin)
        data = finallogin.data;
        if (finallogin.status === "success") {
          dispatch(loginSuccess(data));
          history('/dashboard')
        } else {
          dispatch(apiError(finallogin));
        }
      } else {
        sessionStorage.setItem("authUser", JSON.stringify(data));
        dispatch(loginSuccess(data));
        history('/dashboard')
      }
    }
  } catch (error) {
    // Handle error response from backend
    let errorMessage = "Login failed. Please check your credentials.";
    
    // Handle different error formats from backend
    if (error.message) {
      // If error.message is an array (like ["email should not be empty", "email must be an email"])
      if (Array.isArray(error.message)) {
        errorMessage = error.message.join(", ");
      } else {
        errorMessage = error.message;
      }
    } else if (error.data?.message) {
      if (Array.isArray(error.data.message)) {
        errorMessage = error.data.message.join(", ");
      } else {
        errorMessage = error.data.message;
      }
    } else if (typeof error === 'string') {
      errorMessage = error;
    }
    
    const errorData = {
      message: errorMessage,
      data: error.data || error
    };
    dispatch(apiError(errorData));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    // Check if backend API URL is configured
    const apiUrl = process.env.REACT_APP_API_URL || api.API_URL;
    const useBackend = process.env.REACT_APP_DEFAULTAUTH === "backend" || 
                       !!process.env.REACT_APP_API_URL || 
                       apiUrl.includes("localhost:3000");
    
    if (useBackend) {
      // Call backend logout API (POST /users/logout with body { userId })
      try {
        const user = getLoggedinUser();
        const userId = user?.id ?? user?.userId ?? user?.user_id;
        if (userId) {
          const apiClient = new APIClient();
          await apiClient.create(url.BACKEND_LOGOUT, { userId });
        }
      } catch (error) {
        // Logout endpoint might not exist (404), we still clear local session
        if (error.status !== 404) {
          console.error("Logout API error:", error);
        }
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    }
    
    // Always clear local session storage and authorization header
    sessionStorage.removeItem("authUser");
    setAuthorization(null);
    dispatch(logoutUserSuccess(true));

  } catch (error) {
    // Even on error, clear local session
    sessionStorage.removeItem("authUser");
    setAuthorization(null);
    dispatch(logoutUserSuccess(true));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};